module.exports = __webpack_public_path__ + "static/media/payblock-logo.ecc5d116.png";